import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initGA, trackPerformance } from "./utils/analytics";

// Initialize Google Analytics with tracking ID from environment variables
// Replace 'UA-XXXXXXXXX-X' with your actual tracking ID from Google Analytics
initGA(process.env.REACT_APP_GA_TRACKING_ID);

// Initialize performance tracking
trackPerformance();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
